<template>
  <div>
    <h1>Excursão</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" dense flat>
        <v-toolbar-items>
          <v-btn to="/grouptrips" text>
            <v-icon>view_list</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-menu :v-if="$store.getters.isAccounting" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text>
                <v-icon>list_alt</v-icon>Relatórios
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in reports"
                :key="i"
                @click="showReport(i)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-btn color="error" v-if="this.id" text>Excluir</v-btn> -->
          <v-btn @click="this.save" text>Salvar</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-tabs
            centered
            background-color="primary"
            dark
            slider-color="primary"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab ripple>Ficha</v-tab>
            <v-tab ripple :disabled="!this.id">Roteiro</v-tab>
            <v-tab ripple :disabled="!this.id">Pacotes</v-tab>
            <v-tab ripple :disabled="!this.id">Opcionais</v-tab>
            <v-tab ripple :disabled="!this.id">Voos</v-tab>
            <v-tab ripple :disabled="!this.id">Documentos</v-tab>
            <v-tab ripple :disabled="!this.id">Cáusulas Contratuais</v-tab>
            <v-tab ripple :disabled="!this.id">Permissões</v-tab>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout px-4 pt-4 wrap>
                      <v-flex md8>
                        <v-text-field
                          id="name"
                          name="name"
                          label="Nome da Excursão"
                          v-model="groupTrip.name"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1>
                        <v-text-field
                          id="numberOfSeats"
                          name="numberOfSeats"
                          label="Vagas"
                          v-model="groupTrip.numberOfSeats"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1>
                        <v-text-field
                          id="reservations"
                          name="reservations"
                          label="Reservas"
                          readonly
                          v-model="stats.reservedSeats"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1>
                        <v-text-field
                          id="confirmed"
                          name="confirmed"
                          label="Confirmados"
                          readonly
                          v-model="stats.confirmedSeats"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1>
                        <v-text-field
                          id="availability"
                          name="availability"
                          label="Disponibilidade"
                          readonly
                          :value="
                            groupTrip.numberOfSeats -
                              stats.reservedSeats -
                              stats.confirmedSeats
                          "
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2>
                        <DatePicker
                          name="departureDate"
                          label="Data de Saída"
                          id="departureDate"
                          v-model="departureDate"
                        />
                      </v-flex>
                      <v-flex md2>
                        <TimePicker
                          name="departureTime"
                          label="Hora de Saída"
                          id="departureTime"
                          v-model="departureTime"
                        />
                      </v-flex>
                      <v-flex md8>
                        <v-text-field
                          id="departurePlace"
                          name="departurePlace"
                          label="Local de Saída"
                          v-model="groupTrip.departurePlace"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2>
                        <DatePicker
                          name="returnDate"
                          label="Data de Retorno"
                          id="returnDate"
                          v-model="returnDate"
                        />
                      </v-flex>
                      <v-flex md2>
                        <TimePicker
                          name="returnTime"
                          label="Hora de Saída"
                          id="returnTime"
                          v-model="returnTime"
                        />
                      </v-flex>
                      <v-flex md8>
                        <v-text-field
                          id="returnPlace"
                          name="returnPlace"
                          label="Local de Retorno"
                          v-model="groupTrip.returnPlace"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2>
                        <MoneyInput
                          id="flightCosts"
                          name="flightCosts"
                          label="Valor Aéreo"
                          type="number"
                          min="0"
                          v-model="groupTrip.flightCosts"
                        ></MoneyInput>
                      </v-flex>
                      <v-flex md2>
                        <MoneyInput
                          id="bonusAmount"
                          name="bonusAmount"
                          label="Valor Bônus"
                          type="number"
                          min="0"
                          v-model="groupTrip.bonusAmount"
                        ></MoneyInput>
                      </v-flex>
                      <v-flex md2>
                        <v-text-field
                          id="commissionPercentage"
                          name="commissionPercentage"
                          label="Comissão (%)"
                          type="number"
                          min="0"
                          v-model="groupTrip.commissionPercentage"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <Combobox
                          label="Responsável pela Excursão"
                          searchEndpoint="/users"
                          item-text="name"
                          item-value="id"
                          v-model="groupTrip.responsibleUserId"
                        ></Combobox>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout px-4 pt-4 wrap>
                      <v-flex md12>
                        <v-textarea
                          label="Descrição da Excursão"
                          name="description"
                          v-model="groupTrip.description"
                        ></v-textarea>
                      </v-flex>
                      <v-flex md10></v-flex>
                      <v-flex md2>
                        <v-switch
                          v-model="groupTrip.canGenerateVouchers"
                          label="Liberar Vouchers"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout px-4 pt-4 wrap>
                      <v-flex md12>
                        <v-textarea
                          label="Descrição do roteiro terrestre"
                          name="intinerary"
                          rows="10"
                          v-model="groupTrip.intinerary"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex md12 mt-3>
                  <StayManagement :trip-id="this.id" @loaded="staysLoaded" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <PackageManagement :trip-id="this.id" :stays="stays" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <AddOnManagement :trip-id="this.id" :stays="stays" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <FlightManagement :trip-id="this.id" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <DocumentCheckManagement :trip-id="this.id" />
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout px-4 pt-4 wrap>
                      <v-flex md12>
                        <v-textarea
                          label="Cláusulas contratuais personalizadas"
                          name="contractClauses"
                          rows="30"
                          v-model="groupTrip.contractClauses"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout px-4 wrap>
                      <v-flex xs12>
                        <Combobox
                          label="Selecione uma unidade para dar acesso restrito"
                          searchEndpoint="/branches"
                          item-text="name"
                          item-value="id"
                          ref="restrictedBranchPicker"
                          @change="onSelectedRestrictedBranch"
                        ></Combobox>
                      </v-flex>
                      <v-flex md12>
                        <v-list v-if="restrictedTo.length > 0" two-line>
                          <template v-for="(item, i) in restrictedTo">
                            <v-divider
                              v-if="i > 0"
                              :key="`divider_branch_${item.id}`"
                            ></v-divider>
                            <v-list-item ripple :key="`tile_branch_${item.id}`">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ item.city }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn
                                  text
                                  icon
                                  @click="removeRestrictedBranch(item)"
                                >
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </template>
                        </v-list>
                        <v-flex md12 v-else>
                          <v-card dark color="info">
                            <v-card-text>
                              Todas as Unidades podem utilizar esta excursão.
                              Caso deseje restringir o acesso, selecione as
                              unidades que terão acesso utilizando o filtro
                              acima.
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
    <OperationStatusCard
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
    <v-dialog :value="reportDialog" persistent max-width="80%">
      <v-card>
        <v-card-title class="headline">{{ this.reportTitle }}</v-card-title>
        <v-card-text>
          <iframe
            width="100%"
            height="500px"
            :src="this.reportUrl"
            frameborder="0"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeReport">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "@/api";
import Combobox from "@/components/Shared/Combobox";
import DatePicker from "@/components/Shared/DatePicker";
import TimePicker from "@/components/Shared/TimePicker";
import MoneyInput from "@/components/Shared/MoneyInput";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
import PackageManagement from "@/components/Trip/PackageManagement";
import StayManagement from "@/components/Trip/StayManagement";
import AddOnManagement from "@/components/Trip/AddOnManagement";
import FlightManagement from "@/components/Trip/FlightManagement";
import DocumentCheckManagement from "@/components/Trip/DocumentCheckManagement";
export default {
  name: "group-trip-form",
  components: {
    Combobox,
    DatePicker,
    MoneyInput,
    TimePicker,
    OperationStatusCard,
    PackageManagement,
    StayManagement,
    AddOnManagement,
    FlightManagement,
    DocumentCheckManagement
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  data() {
    return {
      departureDate: null,
      departureTime: null,
      returnDate: null,
      returnTime: null,
      groupTrip: {
        flightCosts: 0,
        bonusAmount: 0,
        numberOfSeats: 0,
        description: "",
        intinerary: ""
      },
      stats: {
        reservedSeats: 0,
        confirmedSeats: 0
      },
      stays: [],
      restrictedTo: [],
      reportTitle: null,
      reportDialog: false,
      reportUrl: null,
      reports: [
        {
          title: "Vendas",
          url: `/reports/grouptrips/${this.$route.params.id}/accounting/sales`
        },
        {
          title: "Extrato",
          url: `/reports/grouptrips/${this.$route.params.id}/accounting/summary`
        }
      ]
    };
  },
  watch: {
    departureDate(newVal) {
      var date = this.$moment(
        newVal + "T" + this.departureTime,
        "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm");
      this.groupTrip.departureDate = date;
    },
    departureTime(newVal) {
      var date = this.$moment(
        this.departureDate + "T" + newVal,
        "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm");
      this.groupTrip.departureDate = date;
    },
    returnDate(newVal) {
      var date = this.$moment(
        newVal + "T" + this.returnTime,
        "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm");
      this.groupTrip.returnDate = date;
    },
    returnTime(newVal) {
      var date = this.$moment(
        this.returnDate + "T" + newVal,
        "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm");
      this.groupTrip.returnDate = date;
    }
  },
  methods: {
    onSelectedRestrictedBranch(selectedBranch) {
      this.$refs.restrictedBranchPicker.clear();
      if (!selectedBranch) return;
      this.removeRestrictedBranch(selectedBranch);
      this.restrictedTo.push({
        id: selectedBranch.id,
        name: selectedBranch.name,
        city: selectedBranch.city
      });
    },
    removeRestrictedBranch(branch) {
      var restrictedTo = [];
      this.restrictedTo.map(b => {
        if (b && b.id !== branch.id) {
          restrictedTo.push(b);
        }
      });
      this.restrictedTo = restrictedTo;
    },
    staysLoaded(stays) {
      this.stays = stays;
    },
    save() {
      this.$refs.operationStatusCard.show();
      var endpoint = this.id
        ? `/trips/grouptrips/${this.id}`
        : `/trips/grouptrips`;
      var method = this.id ? "PUT" : "POST";
      var payload = this.id
        ? {
            groupTrip: this.groupTrip,
            restrictedTo: this.restrictedTo.map(_ => _.id)
          }
        : this.groupTrip;
      api
        .request(method, endpoint, payload)
        .then(response => {
          this.$refs.operationStatusCard.succeed();
          if (!this.id) {
            this.$router.push(`/grouptrip/${response.data.id}`);
          }
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    },
    showReport(reportIndex) {
      this.reportTitle = this.reports[reportIndex].title;
      api
        .request("GET", this.reports[reportIndex].url, null, {}, "arraybuffer")
        .then(response => {
          this.reportUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          this.reportDialog = true;
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    closeReport() {
      window.URL.revokeObjectURL(this.reportUrl);
      this.reportUrl = null;
      this.reportTitle = null;
      this.reportDialog = false;
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/trips/groupTrips/${this.id}`)
        .then(response => {
          this.groupTrip = response.data.groupTrip;
          this.restrictedTo = response.data.restrictedTo || [];
          this.stats = response.data.stats;

          if (this.groupTrip.departureDate) {
            this.departureDate = this.$moment(
              this.groupTrip.departureDate
            ).format("YYYY-MM-DD");
            this.departureTime = this.$moment(
              this.groupTrip.departureDate
            ).format("HH:mm");
          }

          if (this.groupTrip.returnDate) {
            this.returnDate = this.$moment(this.groupTrip.returnDate).format(
              "YYYY-MM-DD"
            );
            this.returnTime = this.$moment(this.groupTrip.returnDate).format(
              "HH:mm"
            );
          }
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    }
  }
};
</script>
